import type { ChartSpec, QueryRow } from '../../services/api/dataQa';

export type ChartSeries = {
  labels: string[];
  series: { name: string; values: (number | null)[] }[];
};

// Postgres skickar numeric och bigint som strängar i JSON; de ska ritas som tal.
export const toNumber = (value: unknown): number | null => {
  if (typeof value === 'number') return Number.isFinite(value) ? value : null;
  if (typeof value === 'string' && value.trim() !== '' && !Number.isNaN(Number(value))) {
    return Number(value);
  }
  return null;
};

const ISO_DATE = /^(\d{4})-(\d{2})-(\d{2})(?:[T ].*)?$/;

const dateLabel = new Intl.DateTimeFormat('sv-SE', {
  day: 'numeric',
  month: 'short',
  timeZone: 'UTC',
});

export const formatLabel = (value: unknown): string => {
  if (value === null || value === undefined) return '–';
  const text = String(value);
  const match = ISO_DATE.exec(text);
  if (!match) return text;
  const [, year, month, day] = match;
  return dateLabel.format(new Date(Date.UTC(Number(year), Number(month) - 1, Number(day))));
};

export const chartSeries = (spec: ChartSpec, rows: QueryRow[]): ChartSeries | null => {
  if (rows.length < 2) return null;
  const labels = rows.map((row) => formatLabel(row[spec.x]));
  const series = spec.y
    .map((column, i) => ({
      name: spec.labels?.[i] ?? column,
      values: rows.map((row) => toNumber(row[column])),
    }))
    .filter((s) => s.values.some((v) => v !== null));
  return series.length > 0 ? { labels, series } : null;
};
